<p #pElement class="text show-trimmed" [ngClass]="{ 'show-less': !showAll }">
  {{ text }}
</p>

@if (overflows && !showAll) {
<div class="control-link">
  <a (click)="showAll = true">(show more)</a>
</div>
} @if (overflows && showAll) {
<div class="control-link">
  <a (click)="showAll = false">(show less)</a>
</div>
}
